import { Component } from '@ecs/Component';

export type ShipShape =
  | 'fighter'      // player classes
  | 'dart'
  | 'gunship'
  | 'longbow'
  | 'warden'
  | 'interceptor'  // standard enemy
  | 'lancer'       // railgun enemy
  | 'bomber'       // torpedo enemy
  | 'swarmer'
  | 'dreadnought'
  | 'aegis'
  | 'minelayer'
  | 'carrier'
  | 'torpedo'
  | 'mothership';  // player home base

export type EffectShape =
  | 'particle'  // glowing dot
  | 'spark'     // streak aligned with velocity
  | 'ring'      // expanding shockwave outline
  | 'smoke'     // soft, non-additive puff
  | 'bolt'      // energy projectile
  | 'mine';

export type ShapeType = 'triangle' | 'circle' | ShipShape | EffectShape;

export class Renderable implements Component {
  readonly type = 'Renderable';

  constructor(
    public shape: ShapeType,
    public color: string,
    public size: number,
    public strokeColor?: string,
    public lineWidth: number = 2,
    public shadowColor?: string,
    public shadowBlur: number = 0,
    public alpha: number = 1
  ) {}
}